import { createSlice } from "@reduxjs/toolkit"
const initialState = {
  _id: '',
  name: '',
  img: '',
  email: '',
  teams: [],
  invitesFrom: {},
  currentTeam: emptyTeam,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setName: (state, action) => {
      state.name = action.payload
    },
    setImg: (state, action) => {
      state.img = action.payload
    },
    addTeam: (state, action) => {
      let teams = state.teams
      teams.push(action.payload)
      state.teams = teams
    },
    editTeam: (state, action) => {
      let teams = state.teams
      let ct = state.currentTeam
      teams = teams.map(team => {
        if (team._id !== action.payload._id) return team
        const c = { ...team, ...action.payload }
        ct = c
        return c
      })
      state.teams = teams
      state.currentTeam = ct
    },
    deleteTeam: (state, action) => {
      let teams = state.teams
      teams = teams.filter(team => team._id !== action.payload)
      state.teams = teams
      state.currentTeam = state.currentTeam._id === action.payload ? teams.length ? teams[0] : emptyTeam : state.currentTeam
    },
    setCurrentTeam: (state, action) => {
      state.currentTeam = action.payload
    },
    login: (state, action) => {
      state._id = action.payload._id
      state.name = action.payload.name
      state.img = action.payload.img
      state.email = action.payload.email
      state.teams = action.payload.teams
      state.invitesFrom = action.payload.invitesFrom
      state.currentTeam = action.payload.teams.length ? action.payload.teams[0] : emptyTeam
    },
    logout: (state) => {
      state._id = ''
      state.name = ''
      state.img = ''
      state.email = ''
      state.teams = []
      state.invitesFrom = {}
      state.currentTeam = emptyTeam
      document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }
})

export const {
  setName,
  setImg,
  addTeam,
  editTeam,
  deleteTeam,
  setCurrentTeam,
  login,
  logout,
} = userSlice.actions

export default userSlice.reducer

var emptyTeam = {
  _id: '',
  channelName: '',
  channelImage: '',
  teamGmail: '',
  members: [],
  invitesTo: {},
  departments: {},
}
